/**
 * @generated SignedSource<<7e511cb04459ab67404ecc040ee86308>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type getTrelloWorkspacesQuery$variables = Record<PropertyKey, never>;
export type getTrelloWorkspacesQuery$data = {
  readonly trello: {
    readonly me: {
      readonly workspaces: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string | null | undefined;
            readonly enterprise: {
              readonly atlassianOrganization: {
                readonly id: string;
              } | null | undefined;
            } | null | undefined;
            readonly id: string;
          } | null | undefined;
        }> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getTrelloWorkspacesQuery = {
  response: getTrelloWorkspacesQuery$data;
  variables: getTrelloWorkspacesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "TrelloAtlassianOrganization",
  "kind": "LinkedField",
  "name": "atlassianOrganization",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "getTrelloWorkspacesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TrelloQueryApi",
        "kind": "LinkedField",
        "name": "trello",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TrelloMember",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v0/*: any*/),
                "concreteType": "TrelloMemberWorkspaceConnection",
                "kind": "LinkedField",
                "name": "workspaces",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrelloMemberWorkspaceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TrelloWorkspace",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TrelloEnterprise",
                            "kind": "LinkedField",
                            "name": "enterprise",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "workspaces(first:10)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "getTrelloWorkspacesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TrelloQueryApi",
        "kind": "LinkedField",
        "name": "trello",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TrelloMember",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v0/*: any*/),
                "concreteType": "TrelloMemberWorkspaceConnection",
                "kind": "LinkedField",
                "name": "workspaces",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrelloMemberWorkspaceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TrelloWorkspace",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TrelloEnterprise",
                            "kind": "LinkedField",
                            "name": "enterprise",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "workspaces(first:10)"
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e6cfcbcd7801a58b6fd290fb4dff1eb5",
    "id": null,
    "metadata": {},
    "name": "getTrelloWorkspacesQuery",
    "operationKind": "query",
    "text": "query getTrelloWorkspacesQuery {\n  trello {\n    me @optIn(to: \"TrelloMe\") {\n      workspaces(first: 10) {\n        edges {\n          node {\n            id\n            displayName\n            enterprise {\n              atlassianOrganization {\n                id\n              }\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5b9cbc825d5cbc6d5910c4bf6cdae31e";

export default node;
